// extracted by mini-css-extract-plugin
export default {"PopUp":"Popup_PopUp__y1Uz7","PopUpInner":"Popup_PopUpInner__Wp9kZ","fade":"Popup_fade__V7ZyZ"};